import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserState, User } from './user.state.interface';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUser = createSelector(selectUserState, (state: UserState) => state.user);
export const selectUserName = createSelector(selectUser, (user: User | null) => {
  if (!user) return null;
  
  // Try fullName first, then firstName + lastName, then email, then userId
  if (user.fullName?.trim()) return user.fullName.trim();
  
  const firstName = user.firstName?.trim() || '';
  const lastName = user.lastName?.trim() || '';
  if (firstName || lastName) return `${firstName} ${lastName}`.trim();
  
  if (user.email?.trim()) return user.email.trim();
  
  if (user.userId || user.id) return user.userId || user.id;
  
  return 'User';
});
export const selectIsAuthenticated = createSelector(selectUser, (user: User | null) => !!user);